import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
// Chartjs provides bundle-reducing options https://www.chartjs.org/docs/latest/getting-started/integration.html#quick-start
// eslint-disable-next-line no-unused-vars
import Chart from 'chart.js/auto';
// eslint-disable-next-line no-unused-vars
import autocolors from 'chartjs-plugin-autocolors';
import { Bar, Bubble, Doughnut, Line, Pie } from 'react-chartjs-2';
import { Card, CardBody, CardHeader, CardText, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
const graphComponents = {
  Bar,
  Bubble,
  Doughnut,
  Line,
  Pie
};
const DashboardItem = _ref => {
  let _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    onRemove = _ref.onRemove,
    title = _ref.title;
  // default display if no information is available
  let chart = /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }, "Information not available");
  const data = config.data,
    _config$data = config.data,
    _config$data2 = _config$data === void 0 ? {} : _config$data,
    _config$data2$labels = _config$data2.labels,
    labels = _config$data2$labels === void 0 ? [] : _config$data2$labels,
    options = config.options,
    serializedOptions = config.serializedOptions,
    type = config.type;
  if (labels.length) {
    const Graph = graphComponents[type];

    // deserialize options with JS callbacks from Dashboard.options in the csv repo
    let configuredOptions = {};
    if (serializedOptions) {
      // eslint-disable-next-line no-eval
      configuredOptions = eval(serializedOptions);
    }
    const allOptions = _objectSpread(_objectSpread(_objectSpread({}, options), configuredOptions), {}, {
      plugins: _objectSpread(_objectSpread({
        autocolors: {
          mode: 'label'
        }
      }, options === null || options === void 0 ? void 0 : options.plugins), configuredOptions.plugins)
    });
    chart = /*#__PURE__*/React.createElement(Graph, {
      data: data,
      options: allOptions
    });
  }
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      height: 'inherit'
    }
  }, /*#__PURE__*/React.createElement(CardBody, {
    style: {
      padding: '0px',
      width: 'inherit',
      height: 'inherit'
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading",
    style: {
      paddingBottom: '10px'
    }
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("b", {
    "data-testid": "t-di-title",
    className: "t-di-title"
  }, title)), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement("span", {
    role: "button",
    tabIndex: 0,
    style: {
      outline: 'none',
      cursor: 'pointer'
    },
    onClick: onRemove.bind(this, title),
    onKeyUp: onRemove.bind(this, title)
    // prevent dragable movement being propagated to reqct-grid-layout
    // when close button is clicked
    ,
    onMouseDown: e => e.stopPropagation(),
    "data-testid": "t-di-removeButton"
  }, "x")))), /*#__PURE__*/React.createElement(CardText, {
    style: {
      padding: '.75em',
      height: '85%',
      width: '100%'
    },
    "data-testid": "t-di-chart"
  }, chart)));
};
DashboardItem.propTypes = {
  config: PropTypes.shape({
    data: PropTypes.shape({
      datasets: PropTypes.arrayOf(PropTypes.shape({})),
      labels: PropTypes.arrayOf(PropTypes.string)
    }),
    options: PropTypes.shape({
      plugins: PropTypes.shape({})
    }),
    serializedOptions: PropTypes.string,
    type: PropTypes.string
  }),
  onRemove: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};
export default DashboardItem;